module.exports = __webpack_public_path__ + "static/media/x.9a0528e3.svg";